import MuiDialog from '@mui/material/Dialog';
import { alpha } from '@mui/material/styles';
import { mergeSlotProps } from '@mui/material/utils';
import { forwardRef } from 'react';
import palette from '../palette';
import isScrollLocked from './isScrollLocked';
import { jsx as _jsx } from "react/jsx-runtime";
const BACKDROP_COLOURS = {
  secondary: alpha(palette.INDIGO, 0.7),
  default: alpha(palette.INK, 0.7)
};
const Dialog = forwardRef(({
  color = 'secondary',
  fullScreen,
  maxWidth,
  onClose,
  slotProps,
  PaperProps,
  BackdropProps,
  TransitionProps,
  disableBackdropClick,
  disableEscapeKeyDown,
  ...props
}, ref) => {
  var _slotProps$transition;
  return _jsx(MuiDialog, {
    ref: ref,
    fullScreen: fullScreen,
    maxWidth: maxWidth,
    onClose: (event, reason) => {
      if (reason === 'backdropClick' && disableBackdropClick) return;
      if (reason === 'escapeKeyDown' && disableEscapeKeyDown) return;
      onClose === null || onClose === void 0 ? void 0 : onClose(event, reason);
    },
    slotProps: {
      ...slotProps,
      backdrop: mergeSlotProps(slotProps === null || slotProps === void 0 ? void 0 : slotProps.backdrop, BackdropProps !== null && BackdropProps !== void 0 ? BackdropProps : {
        sx: {
          backgroundColor: BACKDROP_COLOURS[color]
        }
      }),
      paper: mergeSlotProps(slotProps === null || slotProps === void 0 ? void 0 : slotProps.paper, mergeSlotProps(PaperProps, {
        sx: [{
          boxShadow: `0px 4px 32px -2px ${palette.INK_20}`
        }, !fullScreen && {
          borderRadius: '16px'
        }, maxWidth === 'md' && {
          maxWidth: '880px'
        }]
      })),
      transition: (_slotProps$transition = slotProps === null || slotProps === void 0 ? void 0 : slotProps.transition) !== null && _slotProps$transition !== void 0 ? _slotProps$transition : TransitionProps
    },
    disableScrollLock: isScrollLocked(),
    ...props
  });
});
export default Dialog;